export default __webpack_public_path__ + "static/media/no-search-results.4c648617.svg";